// 登錄設備模塊 - 繁體中文
export default {
  tabs: {
    summary: "登錄IP匯總",
    details: "登錄IP明細",
    device: "設備明細",
  },
  common: {
    totalPrefix: "共計",
    totalSuffix: "條數據",
    download: "下載",
    downloadFilename: "數據明細",
    loading: "拼命加載中",
    empty: "暫無數據",
  },
  placeholders: {
    inputIpLocation: "請輸入IP地理位置",
  },
  columns: {
    ipAddress: "IP地址",
    ipLocation: "IP地理位置",
    loginCount: "登錄次數",
    lastLoginTime: "最近登錄時間",
    port: "端口",
    loginTime: "登錄時間",
    loginWay: "登錄方式",
    deviceName: "設備名",
    deviceId: "Device ID (UUID)",
    client: "客戶端",
    imei: "IMEI",
    mac: "MAC",
  },
};
